export enum EAddressAutocompleteWrapper {
  WIDGET = "widget",
  DRAWER = "drawer",
  DELIVERY_OPTIONS_FORM = "delivery-options-form",
}
